module.exports = __webpack_public_path__ + "static/finance-550b8104656ec71ea819d50d9c287811.jpg";